import { Button, Input } from "antd";
import { Controller, useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router";
import { toast } from "react-toastify";
import "../../index.css";
import apiService from "../../services/apiService";
import "./Auth.css";

type FormValues = {
  email: string;
};

const ForgotPassword = () => {
  const navigate = useNavigate();
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<FormValues>({
    mode: "onBlur", // Validation triggered on blur
  });

  const onSubmit = async (data: FormValues) => {
    try {
      const response: {
        token: string;
        message: string;
      } = await apiService.post("/auth/forgot-password", { email: data.email });
      if (response) {
        localStorage.setItem("email", data.email);
        toast.success(response.message);
        navigate("/verify-email");
      }
    } catch (error:any) {
      toast.error(error.message ? error.message : error);
    }
  };
  return (
    <>
      <div className="login-container container">
        <div className="forgot-password-form">
          <div className="form-header login-header">Forgot Password?</div>
          <p className="form-paragraph">
            Enter the email address associated with your account, and we'll send
            you a link to reset your password.
          </p>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div style={{ paddingTop: "30px" }}>
              <div className="form-label login-label">Email</div>
              {/* <Input size="large" style={{ height: "48px", borderRadius: "4px" }} /> */}

              <Controller
                name="email"
                control={control}
                rules={{
                  required: "Please enter your email!",
                  pattern: {
                    value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                    message: "Please enter a valid email!",
                  },
                }}
                render={({ field }) => (
                  <Input
                    {...field}
                    size="large"
                    className={errors.email ? "ant-input-status-error" : ""}
                    style={{ height: "48px", borderRadius: "4px" }}
                  />
                )}
              />
              {errors.email && (
                <div className="ant-form-item-explain-error">
                  {errors.email.message}
                </div>
              )}
            </div>
            <div style={{ paddingTop: "30px" }}>
              <Button
                color="primary"
                variant="solid"
                size="large"
                className="form-button"
                htmlType="submit"
              >
                Continue
              </Button>
            </div>
            <div className="back-to-login-container">
              <Link to={"/login"} className="back-to-login">
                Back to Login
              </Link>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};
export default ForgotPassword;
